module.exports = new __parcel__URL__("satellite-map.aeff24db.png").toString();